import {useTranslation} from "react-i18next";

export default function useGetRankingFilter () {
    const {t} = useTranslation();

    let rankingFilter = [
        {
            id : 0,
            name : t('sessionType')
        },
        {
            id : 1,
            name : t('yearsOld')
        },
        {
            id : 2,
            name : t('gender')
        },
        {
            id : 3,
            name : t('customField')
        },
        {
            id : 4,
            name : t('sessionTypeAndCustomField')
        }
    ];
    return rankingFilter;
}